import { useState } from "react";

let MinuteFlag = false;
let HourFlag = false;

const TimePicker = ({ isOpen, setIsOpen, setCooktime }) => {
  const Hours = Array.from(Array(24).keys());
  const Minutes = Array.from(Array(59).keys());

  const [hour, setHour] = useState("HH");
  const [minute, setMinute] = useState("MM");

  const onHourClick = (e) => {
    const value = e.target.innerHTML;

    if (!MinuteFlag) {
      setMinute("00");
      MinuteFlag = true;
      HourFlag = true;
    }

    if (parseInt(value) <= 9) {
      setHour(`0${value}`);
      setCooktime(`0${value}:${minute}`);
    } else {
      setHour(value);
      setCooktime(`${value}:${minute}`);
    }
  };

  const onMinuteClick = (e) => {
    const value = e.target.innerHTML;

    if (!HourFlag) {
      setHour("00");
      HourFlag = true;
      MinuteFlag = true;
    }

    if (parseInt(value) <= 9) {
      setMinute(`0${value}`);
      setCooktime(`${hour}:0${value}`);
    } else {
      setMinute(value);
      setCooktime(`${hour}:${value}`);
    }

    if (hour !== "HH") setIsOpen(false);
  };

  return (
    <>
      <div
        type="text"
        className="form-control timer-input"
        name="cooktime"
        placeholder="HH:MM"
        onClick={() => setIsOpen(!isOpen)}
      >
        {`${hour}:${minute}`}
      </div>
      {isOpen && (
        <div className="timer-drop-down">
          <ul className="timer-hours">
            {Hours.map((hour) => (
              <li id="timer-index" key={hour} onClick={onHourClick}>
                {hour}
              </li>
            ))}
          </ul>
          <ul className="timer-minutes">
            {Minutes.map((hour) => (
              <li id="timer-index" key={hour} onClick={onMinuteClick}>
                {hour}
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default TimePicker;
